import React, { FC } from 'react';
import FontCreatorAuthContainer from './fontCreatorAuth/FontCreatorAuthContainer';
import FontCreatorNotAuthContainer from './fontCreatorNotAuth/FontCreatorNotAuthContainer';
import { useAuth } from '../auth/useAuth';

const FontCreatorContainer: FC = () => {
  const { isAuth } = useAuth();

  return (
    <div className="bg-white min-h-screen">
      {isAuth ? <FontCreatorAuthContainer /> : <FontCreatorNotAuthContainer />}
    </div>
  );
};

export default FontCreatorContainer;
